import { CroppingSuitabilityReportModel, Product } from "@agroyaar/sdk";
import { Column } from "@/shared/components/report-template/domain/report-template.interface";

export const averagesGddColumns: Column<CroppingSuitabilityReportModel>[] = [
  {
    field: "crop",
    headerName: " محصول",
    render: (value) => (value as Product).persianName,
  },
  {
    field: "suppliedGrowingDegreeDayMean",
    headerName: "میانگین GDD تامین شده در 30 سال گذشته",
    format: "decimal",
    decimals: 2,
  },
  { field: "growingDegreeDayRequirement", headerName: "GDD مورد نیاز " },
];
